//bookings per year (this year and previous year) -- in use

export default {

    methods: {
        createBarData(arr_ty, arr_py, arr_py3){

            if(!this.checkFormat(arr_ty) || !this.checkFormat(arr_py) || !this.checkFormat(arr_py3)){
                return null;
            }

            let xvalues_ty = [], yvalues_ty = [], maxvalue_ty = 0;
            let yvalues_py = [], maxvalue_py = 0, maxvalue = 0, yvalues_py3 = [];

            for (let i = 0; i < arr_ty.length; i++) {

                yvalues_ty.push(arr_ty[i].nr_bookings)
                if (arr_ty[i].nr_bookings > maxvalue_ty) {
                    maxvalue_ty = arr_ty[i].nr_bookings;
                }
            }

            for (let i = 0; i < arr_py.length; i++) {
                xvalues_ty.push(arr_py[i].week); // 23 Septem
                yvalues_py.push(arr_py[i].nr_bookings)
                yvalues_py3.push(arr_py3[i].nr_bookings)
                if (arr_py[i].nr_bookings > maxvalue_py) {
                    maxvalue_py = arr_py[i].nr_bookings;
                }
                if (arr_py3[i].nr_bookings > maxvalue_py) {
                    maxvalue_py = arr_py3[i].nr_bookings;
                }

            }

            maxvalue = maxvalue_ty;
            if(maxvalue < maxvalue_py){
                maxvalue = maxvalue_py;
            }

            let datasets = [];
            var currentYear = new Date().getFullYear();
            var previousYear = currentYear - 1;
            var previousYear2 = currentYear - 2;
            
            //console.log(yvalues_py3, yvalues_py, yvalues_ty);

            dataset_element = {
                "backgroundColor": "rgb(255,215,0)", // aqua
                "data": yvalues_py3,
                "borderColor": "rgb(255,127,80)", 
                "label": "Bookings " + previousYear2,
                "borderWidth": 2,
            };
            datasets.push(dataset_element);

            // previous year 
            dataset_element = {
                "backgroundColor": "rgb(0, 255, 255)", // aqua
                "data": yvalues_py,
                "borderColor": "rgb(0, 0, 255)", 
                "label": "Bookings " + previousYear,
                "borderWidth": 2,
            };
            datasets.push(dataset_element);
            

            // this year
            let dataset_element = {
                "backgroundColor": "rgb(0, 255, 0)",
                "data": yvalues_ty,
                "borderColor": "rgb(0, 128, 0)", 
                "label": "Bookings " + currentYear,
                "borderWidth": 2,
            };
            datasets.push(dataset_element);

            
            let xdata = {
                "labels": xvalues_ty,
                "datasets": datasets,
            };

            let xminmax = {
                "min": 0,
                "max": this.getMaxValue(maxvalue),
            };
            
            let xscales= {"y": xminmax};
            let xlegend = {
                "legend": {
                    "display": true
                },
                datalabels: {
                    formatter: function(value, context){
                        return context !== null ? value === 0 ? '' : '': '';                         
                    }
                }   
            };

            let xoptions = {
                "plugins": xlegend,
                "responsive": true,
                "maintainAspectRatio": false,
                "lineTension": 0,
                "scales": xscales,
            };
             
            let chartData = {
                "type": "line",
                "data": xdata,
                "options": xoptions,
            };

            return chartData;

        },    
        getMaxValue(v){
            if(v - (((v - v%100) / 100) * 100) <= 50)
                return (((v - v%100) / 100) * 100) + 100
            return ((((v + 100) - v%100) / 100) * 100) + 100
        },                    
        checkFormat(arr) {
            if (!Array.isArray(arr)) {
                console.log("parameter is not an array");
                return false;
            }
            if (arr.length > 0) {
                if (!('nr_bookings' in arr[0] && 'week' in arr[0])) {
                    console.log("array elements have unknown composition");
                    return false;
                }
            }
            return true;
        }        
    }
}